import { useEffect, useState } from "react";
import api from "./api";

let _cache = null;
let _inflight = null;

export function clearFusionAccessCache() { _cache = null; _inflight = null; }

/** {fusion_enabled, biohacker_enabled, loaded} for the logged-in user's team. Cached per session. */
export function useFusionAccess() {
  const [state, setState] = useState(_cache || { fusion_enabled: false, biohacker_enabled: true, loaded: false });
  useEffect(() => {
    if (_cache) { setState(_cache); return; }
    if (!_inflight) {
      _inflight = api.get("/fusion/access")
        .then((r) => { _cache = { ...r.data, loaded: true }; return _cache; })
        .catch(() => ({ fusion_enabled: false, biohacker_enabled: true, loaded: true }));
    }
    let alive = true;
    _inflight.then((v) => { if (alive) setState(v); });
    return () => { alive = false; };
  }, []);
  return state;
}

/** One-shot fetch for post-login redirects. */
export async function fetchFusionAccess() {
  try {
    const { data } = await api.get("/fusion/access");
    _cache = { ...data, loaded: true };
    return data;
  } catch {
    return { fusion_enabled: false, biohacker_enabled: true };
  }
}
